import {useQuery} from '@tanstack/react-query'
import builderConfig from 'hec/builder/model-map'
import {getConfig} from '@salesforce/pwa-kit-runtime/utils/ssr-config'
import {fetchOneEntry} from '@builder.io/sdk-react'

const useFetchGoal = (goalContentID) => {
    const apiKey = getConfig().app.builder.api
    const fetchBuilderContent = (model, contentID) =>
        fetchOneEntry({
            apiKey: apiKey,
            model: model,
            query: {
                id: contentID
            },
            fields: 'id,data'
        })

    return useQuery({
        queryKey: ['Fetch-Learning-Center-Goal', goalContentID],
        queryFn: async () => {
            const response = await fetchOneEntry({
                apiKey: apiKey,
                model: builderConfig.learningCenterGoal,
                query: {
                    id: goalContentID
                },
                fields: 'id,data'
            })

            await Promise.all(
                response.data.levels.map(async (builderLevel) => {
                    const builderModules = builderLevel.level.value.data.modules
                    await Promise.all(
                        builderModules.map(async (builderModule) => {
                            const moduleRes = await fetchBuilderContent(
                                builderConfig.learningCenterModule,
                                builderModule.module.id
                            )
                            builderModule.module = moduleRes
                        })
                    )
                })
            )

            return response
        },
        enabled: !!goalContentID
    })
}

export default useFetchGoal
